import firebase from 'firebase/compat/app';
import withoutNulls from '../../api/search/withoutNulls';
import STORE_CONSTANTS from '../constants';

const converter = {
  toFirestore(
    reasonCode: BonusReasonCodes.ReasonCode,
  ): firebase.firestore.DocumentData {
    return withoutNulls({ ...reasonCode });
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<BonusReasonCodes.ReasonCode>,
    options: firebase.firestore.SnapshotOptions,
  ): BonusReasonCodes.ReasonCode {
    return {
      ...snapshot.data(options),
    };
  },
};

// Staff-managed reason codes for driver-bonus overrides, stored as a
// subcollection of the bonus program they belong to
// (driverBonus/{bonusProgramId}/reasonCodes). The program scopes the codes by
// path, so callers just list the collection and address docs by id (`.doc(id)`)
// when adding/removing — no per-program query needed.
const getBonusReasonCodesRef = ({
  accountId,
  bonusProgramId,
  db,
}: {
  accountId: string;
  bonusProgramId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_COLLECTION)
    .doc(bonusProgramId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_REASON_CODES_SUBCOLLECTION)
    .withConverter(converter);
};

export default getBonusReasonCodesRef;
